import { useContext, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Button } from '@cbhq/cds-web/buttons/Button';
import '../../Link/index.js';
import UrlContext from '../context/UrlContext.js';
import messages from '../messages.js';
import { jsx } from 'react/jsx-runtime';
import Link from '../../Link/Link.js';
function SignUpButtonUboExperiment() {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const _useContext = useContext(UrlContext),
    coinbaseAccountsBaseUrl = _useContext.coinbaseAccountsBaseUrl;
  const uboUrl = useMemo(() => {
    return new URL('pick-your-account?origin=coinbase.com', coinbaseAccountsBaseUrl).toString();
  }, [coinbaseAccountsBaseUrl]);
  return /*#__PURE__*/jsx(Link, {
    logEvents: true,
    to: uboUrl,
    title: formatMessage(messages.signUpLink),
    testID: "header-get-started-button-ubo-experiment",
    children: /*#__PURE__*/jsx(Button, {
      compact: true,
      analyticsId: "05434ddb-57aa-42c4-a96a-7d0a2ef44aa3",
      children: formatMessage(messages.signUpLink)
    })
  });
}
export { SignUpButtonUboExperiment as default };
//# sourceMappingURL=SignUpButtonUboExperiment.js.map
